import BaseModelAPI from '../BaseModelAPI';

export default class Post extends BaseModelAPI {
	static entity = 'post';
	static entityName = 'post';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.title = '';
			this.content = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}